<script lang="ts" setup>
import type { LoadingWrapperColors } from '~/components/loading/wrapper/LoadingWrapper.vue'

export interface LoadingBarProps {
    color: LoadingWrapperColors
}

const props = withDefaults(defineProps<LoadingBarProps>(), {
    color: 'secondary',
})
</script>
<template>
  <LoadingWrapper
    :color="props.color"
    animation="rotate"
  >
    <img
      loading="lazy"
      decoding="async"
      src="~/assets/icons/redo-alt.svg"
      width="16"
      height="16"
      alt=""
      class="loading-bar-icon d-block transition"
    >
  </LoadingWrapper>
</template>
